/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { blackMaterial } from "../../../common/materials";
import { useSection } from "../../../common/hooks";
import { SECTIONS } from "../../../constants/sections";

const model = "/models/sofa.glb";

export default function Sofa({ ...props }) {
  const group = useRef();
  const { nodes } = useGLTF(model);
  const { currentSection } = useSection();
  return (
    currentSection.name !== SECTIONS.HOBBIES && (
      <group ref={group} {...props} dispose={null} castShadow receiveShadow>
        <mesh
          receiveShadow
          geometry={nodes.sofa.geometry}
          material={blackMaterial}
          position={[0.5, 0.67, -2.53]}
        />
      </group>
    )
  );
}

useGLTF.preload(model);
